
































































































import _ from 'underscore';
import { Component, Vue } from 'vue-property-decorator';
import { StudentProfile } from '@/classes/StudentProfile';
import { sprintf } from 'sprintf-js';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import Certification from '@/classes/Certification';
import Certificate from '@/classes/Certificate';
import dateFns from 'date-fns';
import binaryDownload from '@/services/BinaryDownloader';

@Component
export default class Search extends Vue {
  private currPage: number = 1;
  private perPage: number = 10;

  get currentPage(): number {
    if (this.currPage > this.pages) {
      return this.pages;
    } else {
      return this.currPage;
    }
  }

  set currentPage(num: number) {
    this.currPage = num;
  }

  get pages(): number {
    return Math.ceil(this.results.length / this.perPage);
  }

  private dolIdFilter: string | null = null;
  private lastNameFilter: string | null = null;
  private statusFilter: boolean | null = null;
  private jobCorpsCenterIdFilter: number = 0;
  private courseNameFilter: number = 0;
  private compDateFromFilter: string | null = null;
  private compDateToFilter: string | null = null;

  private sortKey: string = 'lastName';
  private sortDesc: boolean = false;

  private get results(): StudentProfile[] {
    const students = (this.$store.getters['students/getStudents'] || []) as StudentProfile[];

    const rows = _(students)
      .chain()
      .filter((s: StudentProfile) => !this.dolIdFilter || new RegExp(this.dolIdFilter as string, 'i').test(s.dolId as string))
      .filter((s: StudentProfile) => !this.lastNameFilter || new RegExp(this.lastNameFilter as string, 'i').test(s.lastName as string))
      .filter((s: StudentProfile) => null === this.statusFilter || this.statusFilter === s.active)
      .filter((s: StudentProfile) => {
        const filterId = Number(this.jobCorpsCenterIdFilter);
        const jcCenterId = Number(s.jobCorpsCenterId);
        return !filterId || 0 === filterId || filterId === jcCenterId;
      })
      .filter((s: StudentProfile) => {
        const filterId = Number(this.courseNameFilter);

        if (0 === filterId) {
          return true;
        }

        const certifications = this.$store.getters['certificates/getCertificationsByIds'](s.certificates);
        return _(certifications).any((c: Certification) => filterId === c.id);
      })
      .filter((s: StudentProfile) => {
        let fromDate = !this.compDateFromFilter ? null : new Date(this.compDateFromFilter);
        let toDate = !this.compDateToFilter ? null : new Date(this.compDateToFilter);

        if (!fromDate && !toDate) {
          return true;
        }

        if (!!fromDate && !!toDate && dateFns.isAfter(fromDate, toDate)) {
          const tmp = fromDate;
          fromDate = toDate;
          toDate = tmp;
        }

        const certificates = this.$store.getters['certificates/getCertificatesByIds'](s.certificates) as Certificate[];

        return _(certificates).any((c: Certificate) => {
          const compDate = !c.certificationDate ? null : new Date(c.certificationDate);

          if (null == compDate) {
            return false;
          }

          if (!toDate) {
            return dateFns.isAfter(compDate, fromDate as Date);
          }

          if (!fromDate) {
            return dateFns.isBefore(compDate, toDate);
          }

          return dateFns.isAfter(compDate, fromDate) && dateFns.isBefore(compDate, toDate);
        });
      })
      .value();

    let sortedRows: StudentProfile[] = rows;

    switch (this.sortKey) {
      case 'dolId':
        sortedRows = _(rows).sortBy((s: StudentProfile) => s.dolId);
        break;

      case 'jobCorpsCenter':
        sortedRows = _(rows).sortBy((s: StudentProfile) => {
          const center = s.jobCorpsCenter;
          return null == center ? '' : center.name;
        });

        break;

      case 'lastName':
      default:
        sortedRows = _(rows)
          .chain()
          .sortBy((s: StudentProfile) => s.firstName)
          .sortBy((s: StudentProfile) => s.lastName)
          .value();
        break;
    }

    return this.sortDesc ? sortedRows.reverse() : sortedRows;
  }

  get jobCorpsCenters(): JobCorpsCenter[] {
    return this.$store.getters.getJobCorpsCentersAllowed;
  }

  get certifications(): Certification[] {
    return this.$store.getters['certifications/getCertifications'];
  }

  private get fields() {
    return [
      {
        key: 'dolId',
        label: 'Student ID',
        sortable: true
      },
      {
        key: 'lastName',
        label: 'Name',
        sortable: true
      },
      {
        key: 'jobCorpsCenter',
        label: 'Job Corps Center',
        sortable: true
      },
      {
        key: 'status',
        label: 'Status'
      },
      {
        key: 'extra',
        label: ''
      }
    ];
  }

  private clearFilters() {
    this.dolIdFilter = null;
    this.lastNameFilter = null;
    this.statusFilter = null;
    this.jobCorpsCenterIdFilter = 0;
    this.courseNameFilter = 0;
    this.compDateFromFilter = null;
    this.compDateToFilter = null;
  }

  private linkToProfile(id: number): string {
    return `/students/profile/${id}`;
  }

  private getStudentHistory(id: number): void {
    binaryDownload('GET', `/api/v1/report/student_history/${id}`);
  }
}
